import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer, ActionDiv } from "./QuoteServices.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import "../../AddEditQuote.scss";

const QuoteAction = (props) => {
  const {
    t,
    id,
    setCurrentSellingPrice,
    setEnquiryData,
    currentSellingPirceData,
    currentEnquiryData,
    editSellingPrice,
    statusDraft,
    onServiceDelete,
    setCalculateMargin,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const handleSellingPricelDisable = () => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      onServiceDelete(currentSellingPirceData.id);
      setActionConfirmStatus(false);
      setCalculateMargin(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editSellingPriceAction = () => {
    setCurrentSellingPrice(currentSellingPirceData);
    setEnquiryData(currentEnquiryData);
    editSellingPrice(currentSellingPirceData.id);
  };

  return (
    <ActionDiv>
      <ButtonContainer>
        <div>
          {!statusDraft && (
            <Image
              src={editIcon}
              className="add-quote__quote_action_icon"
              title={t("QUOTE_SERVICE_ACTION_TOOLTIP_EDIT")}
              onClick={editSellingPriceAction}
              alt={t("QUOTE_SERVICE_ACTION_TOOLTIP_EDIT")}
            />
          )}
          <Image
            src={deleteIcon}
            onClick={handleSellingPricelDisable}
            alt={t("QUOTE_SERVICE_ACTION_TOOLTIP_DELETE")}
            title={t("QUOTE_SERVICE_ACTION_TOOLTIP_DELETE")}
            className="add-quote__quote_action_icon_no_margin"
          />
        </div>
      </ButtonContainer>

      {isConfirm && <ClipLoader size={15} color="#cccccc" />}

      {isConfirmVisible && (
        <WarningPopUp
          title={t("QUOTE_SERVICE_CONFIRMATION_BOX_DELETE")}
          message={t("QUOTE_SERVICE_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ActionDiv>
  );
};

QuoteAction.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(QuoteAction);
